import React from 'react'

const OffingoBusinessVersionManager = () => {
    return (
        <div>OffingoBusinessVersionManager</div>
    )
}

export default OffingoBusinessVersionManager